import { _ as _defineProperty } from './defineProperty-Y-S4SptN.js';
import { _ as _objectWithoutProperties } from './objectWithoutProperties-w3bsUgPa.js';
import classNames from 'classnames';
import createUseStyles from './create/index.js';
import { canHover } from './helpers/index.js';
import { Transitions } from './enums/index.js';
import { j as jsxRuntimeExports } from './jsx-runtime-KJzvSKZ_.js';

var useStyles = createUseStyles({
  root: _defineProperty(_defineProperty(_defineProperty({
    borderRadius: 4,
    position: 'relative',
    overflow: 'hidden',
    cursor: 'pointer',
    maxWidth: 'fit-content',
    transition: 'background-image 0.5s linear',
    '&:before, &:after': {
      content: '""',
      display: 'block',
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 1,
      pointerEvents: 'none'
    },
    '&:before': {
      borderRadius: 'inherit'
    },
    '&:after': {
      opacity: 0,
      transition: "opacity ".concat(Transitions.Fast, " ease-in-out")
    }
  }, canHover(), {
    '&:not(.active):hover': {
      boxShadow: 'none',
      '&:after': {
        opacity: 1,
        backgroundImage: function backgroundImage(props) {
          return props.showHover ? 'linear-gradient(360deg, rgba(18, 18, 18, 0.44) 0%, rgba(18, 18, 18, 0) 100%)' : 'none';
        }
      },
      '& .hoverPaperHeader, & .hoverPaperFooter, & .hoverPaperBody': {
        display: 'block'
      }
    }
  }), canHover(false), {
    '&:active': {
      '&:after': {
        opacity: 1
      },
      '& .hoverPaperHeader, & .hoverPaperFooter, & .hoverPaperBody': {
        display: 'block'
      }
    }
  }), '&.active', {
    '&:before': {
      boxShadow: '0 0 0 1px var(--accents-primary-base) inset, 0 0 0 3px var(--backgrounds-tint-2) inset'
    }
  })
}, {
  name: 'hover-paper'
});

var _excluded = ["showHover", "children", "selected", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function HoverPaper(_ref) {
  var _ref$showHover = _ref.showHover,
    showHover = _ref$showHover === void 0 ? true : _ref$showHover,
    children = _ref.children,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyles({
    showHover: showHover
  });
  return /*#__PURE__*/jsxRuntimeExports.jsx("div", _objectSpread(_objectSpread({
    className: classNames(styles.root, {
      active: selected
    }, className),
    role: "button"
  }, props), {}, {
    children: children
  }));
}

export { HoverPaper as H };
//# sourceMappingURL=HoverPaper-ulm5jlA-.js.map
